module.exports = __webpack_public_path__ + "static/media/walletconnect.959b3945.svg";